import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=f4ba6a26&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ba6a26",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/Promotion.vue
// module id = null
// module chunks = 